const { onDOMContentLoaded } = require('./domEvents');

function createAddedComponentObserver(componentSelector, componentInitFn) {
  return new MutationObserver((mutationsList) => {
    mutationsList.forEach(
      (mutation) =>
        mutation.type === 'childList'
        && mutation.target.querySelectorAll
        && [...mutation.target.querySelectorAll(componentSelector)].forEach(
          componentInitFn,
        ),
    );
  });
}

module.exports = function createComponentModule(
  componentSelector,
  initFunction,
  ignoreVueComponent = false,
) {
  return {
    initAll() {
      onDOMContentLoaded(() => {
        // Initial configuration
        [...document.querySelectorAll(componentSelector)].forEach(
          this.initComponent,
        );
        // Dinamically added
        createAddedComponentObserver(
          componentSelector,
          this.initComponent,
        ).observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      });
    },

    initComponent(componentRootElement) {
      if (componentRootElement.dataset.initialized === 'true') return;
      if (ignoreVueComponent && componentRootElement.dataset.vue === 'true') return;

      initFunction(componentRootElement);

      // eslint-disable-next-line no-param-reassign
      componentRootElement.dataset.initialized = true;
    },
  };
};
